import React, { useRef } from "react";
import { Calendar, Hospital } from "lucide-react";
import { exchangeDate } from "../../helpers";
import { Drawer } from 'vaul';

export default function CallNoteModal({
  patient_data = {},
  activeModal = false,
  setActiveModal = () => {},
  setCallNoteCallType = () => {},
  setActiveCallNoteCallModal = () => {},
  previousScrollPosition = 0,
  setPreviousCallScrollPosition = () => {},
}) {
  const dropdownRef = useRef(null);

  // const handleCall = (callType) => {
  //   setActiveModal(false);
  //   const url = `/call?name=${encodeURIComponent(patient_data?.firstName)}%20${encodeURIComponent(patient_data?.lastName)}&patient_id=${encodeURIComponent(patient_data?.id)}&phone=${encodeURIComponent(patient_data?.mobilePhone)}&call_type=${encodeURIComponent(callType)}`;
  //   window.open(url, '_blank', 'noopener,noreferrer');
  // };
  

  const handleCall = (callType) => {
    setCallNoteCallType(callType);
    setActiveCallNoteCallModal(true);
    setActiveModal(false);
    window.scrollTo(0, previousScrollPosition);
    setPreviousCallScrollPosition(window.scrollY);
    window.scrollTo(0, 0);
  };

  const handleDrawerClose = () => {
    setActiveModal(false);
    window.scrollTo(0, previousScrollPosition);
  };

  return (
    <div style={{ height: "100%" }} ref={dropdownRef}>
      <Drawer.Root open={activeModal} onOpenChange={handleDrawerClose}>
        <Drawer.Trigger className="docpro_single_patiant_modal_btn">
        </Drawer.Trigger>
        <Drawer.Portal>
          <Drawer.Overlay className="docpro_drawer_overlay"/>
          <Drawer.Content className="docpro_drawer_content docpro_drawer_style_4 small">
            <Drawer.Title className="sr-only">Patient Call Note Modal</Drawer.Title>
            <Drawer.Description className="sr-only">View details of a parient to call</Drawer.Description>
            <div className={`docpro_modal_wrap docpro_style_auto`}>
              <div className="docpro_modal small_sm">
                <div className="modal_height_100">
                  <div style={{ alignItems: "center", margin: "5px", padding: "10px" }} className="patient-info docpro_bg_white">
                    <p className="docpro_fs_18" style={{ textAlign: "center" }}><strong> Reason for call ? </strong></p>
                    <table className="docpro_referral_table">
                      <tbody>
                        <tr>
                          <td style={{ width: '105px' }}><strong className='docpro_indigo_color'>Name</strong></td>
                          <td style={{ width: '15px' }}>:</td>
                          <td>{patient_data?.lastName} {patient_data?.firstName}</td>
                        </tr>
                        <tr>
                          <td><strong className='docpro_indigo_color'>Date of Birth</strong></td>
                          <td>:</td>
                          <td>{exchangeDate(patient_data?.dob)}</td>
                        </tr>
                        <tr>
                          <td><strong className='docpro_indigo_color'>Gender</strong></td>
                          <td>:</td>
                          <td>{patient_data?.gender || patient_data?.sex === "M" ? "Male" : patient_data?.sex === "F" ? "Female" : patient_data?.sex}</td>
                        </tr>
                        <tr>
                          <td><strong className='docpro_indigo_color'>Insurance</strong></td>
                          <td>:</td>
                          <td>{patient_data?.insuranceName}</td>
                        </tr>
                        <tr>
                          <td><strong className='docpro_indigo_color'>Insurance ID</strong></td>
                          <td>:</td>
                          <td>{patient_data?.insuranceID || patient_data?.insurance_code}</td>
                        </tr>
                        <tr>
                          <td><strong className='docpro_indigo_color'>Phone</strong></td>
                          <td>:</td>
                          <td>{patient_data?.mobilePhone || patient_data?.phoneNumber}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div className="action-buttons small_buttons docpro_mt_auto">
                    <button
                      onClick={() => handleCall('scheduling')}
                      className="connect-button action-button"
                    >
                      <Calendar width={20} height={20} />Scheduling
                    </button>
                    {patient_data?.chronicConditions && (
                      <button
                        onClick={() => handleCall('ccm')}
                        className="docpro_bordered_btn action-button"
                        disabled={patient_data?.chronicConditions ? false : true}
                      >
                        <Hospital width={20} height={20} />CCM
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </Drawer.Content>
        </Drawer.Portal>
      </Drawer.Root>
    </div>
  );
}
